var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWalletNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_452_4138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6777 7.80713H21.6777C21.943 7.80713 22.1973 7.91249 22.3848 8.10002C22.5724 8.28756 22.6777 8.54191 22.6777 8.80713V20.8071C22.6777 21.0723 22.5724 21.3267 22.3848 21.5142C22.1973 21.7018 21.943 21.8071 21.6777 21.8071H3.67773C3.41252 21.8071 3.15816 21.7018 2.97063 21.5142C2.78309 21.3267 2.67773 21.0723 2.67773 20.8071V4.80713C2.67773 4.54191 2.78309 4.28756 2.97063 4.10002C3.15816 3.91249 3.41252 3.80713 3.67773 3.80713H18.6777V7.80713ZM4.67773 9.80713V19.8071H20.6777V9.80713H4.67773ZM4.67773 5.80713V7.80713H16.6777V5.80713H4.67773ZM15.6777 13.8071H18.6777V15.8071H15.6777V13.8071Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_4138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "translate(0.677734 0.807129)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletNav);
export default __webpack_public_path__ + "static/media/icon-wallet-nav.a1a7bf47b416467fe8625fd3bfeb808d.svg";
export { ForwardRef as ReactComponent };